export const FULL_DAY = "Full Day";
export const BUTTON_NUMBERS = ["6", "8", "12"];
export const FIRST_TIMEBAND = "00:00";
export const DEFAULT_TIMEBAND = "04:00:00";
export const DEFAULT_TIMERANGE = 8;
